import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool, utils_tool } from "@/tool";
import columns from "./columns";
import moment from "moment";
import _ from 'lodash'
import { parse } from "querystring";
import "moment-timer";
import "./index.less";
import { message } from "antd";
import Conference from "./components/conference";

const { WizContainer, modelUtils } = framework_tool;
const {
  WizSpin,
  WizTabs,
  WizDataTable,
  WizButton,
  WizModal,
  WizInput,
  WizEmpty,
  WizRow,
  WizCol
} = component_tool;
let { Session } = utils_tool

const { getPageData } = utils_tool;
//const getPageQuery = () => parse(window.location.href.split("?")[1]);
const { id = 1, personId = "1", remoteAuthId = 1, authState = 0, fullName = '' } = Session.get('hktClassroomInfo') || {};

class smartClassroomRemote extends WizContainer {
  // 组件名 必传
  componentName = "smartClassroomRemote";

  // 构造函数
  constructor(props) {
    super(props);
    this.state = {
      isStart: false,
      isReady: false,
      isOver: false,
      tabActiveKey: 0,
      allData: [],
      totalScore: 0,
      moduleState: "开始",
      tableKey: "tableKey",
      currentModuleScore: 0,
      currentModuleTotalScore: 0
    };
  }

  componentWillMount() {
    if (authState == 2) {
      this.setState({ isReady: true })
    }
  }

  componentDidMount() {
    // 加入防抖
    window.addEventListener('resize', _.debounce(() => {
      this.setState({ tableKey: new Date().getTime() })
    }, 500))
    this._getData();
  }

  // 监听属性和状态的变化
  propsAndStateOnChange = {
    list: this._list.bind(this),
    listOfChange: this._listOfChange.bind(this),
    changeModuleState: this._changeModuleState.bind(this),
    saveExam: this._saveExam.bind(this)
  };

  // 提交后,弹出关闭提示
  _saveExam(nextProps, nextState) {
    if (nextProps.saveExam.success) {

      let secondsToGo = 3;

      // 非脚本打开无法调用close,直接替换为空白页
      const modal = WizModal.success({
        content: `认证完成, ${secondsToGo} s 后页面自动关闭`,
        okText: '关闭窗口',
        keyboard: false,
        onOk: () => {
          clearInterval(timer);
          modal.destroy();
          window.location.replace("about:blank");
          window.close();
        }
      });

      const timer = setInterval(() => {
        secondsToGo -= 1;
        modal.update({
          content: `认证完成, ${secondsToGo} s 后页面自动关闭`,
        });
      }, 1000);

      setTimeout(() => {
        clearInterval(timer);
        modal.destroy();
        window.location.replace("about:blank");
        window.close();
      }, secondsToGo * 1000);

    }
    return false
  }

  _list(nextProps, nextState) {
    if (nextProps.list.success) {
      nextState.allData = nextProps.list.data || [];
      this.updateTotalScore(nextState.allData);
      // nextState.allData.length && nextState.allData.forEach((val,index) => {
      //   console.log('val', val);
      //   if(val.remainingTime === 0) {
      //     this._handleChangeModuleState(false, index)
      //   }
      // })
      return true;
    }
    return false
  }

  _listOfChange(nextProps, nextState) {
    if (nextProps.listOfChange.success) {
      nextState.allData = nextProps.listOfChange.data || [];
      this.updateTotalScore(nextState.allData);
      return true;
    }
    return false
  }

  _changeModuleState(nextProps, nextState) {
    if (nextProps.changeModuleState.success) {
      this._getData()
      return true
    }
    return false;
  }

  //获取listPage数据
  _getData(other = {}, isupdate) {
    let studentExamPaper = isupdate
      ? "changeStudentExamPaper"
      : "getStudentExamPaper";
    this.doAction({
      path: `studentRemoteAuthDetailOfList/${studentExamPaper}`,
      payload: {
        key: studentExamPaper,
        apiParams: {
          personId,
          entityId: personId,
          id,
          remoteAuthId,
          ...other,
        },
      },
    });
  }

  // 保存考卷
  _handleSave({ isOver }) {
    if (isOver) {

    }
    this.doAction({
      path: "studentRemoteAuthDetail/saveStudentExamPaper",
      payload: {
        key: isOver ? "saveStudentExamPaperToEnd" : "_saveStudentExamPaper",
        apiParams: {
          personId,
          remoteAuthDetailId: id,
          isOver,
          infoList: this.state.allData,
        },
      },
    });
  }

  // 更改考卷状态 开始认证 --> 结束认证
  _updateAuthState() {
    const params = { id, authState: 2 };
    this.doAction({
      path: "studentRemoteAuthDetail/updateAuthState",
      payload: {
        key: "saveStudentExamPaper",
        apiParams: { ...params },
      },
    });
  }

  // 更改单个模块状态
  _handleChangeModuleState(startState, index) {
    const { allData } = this.state
    const studentModuleRelationId = allData[index].id
    this.doAction({
      path: "studentModuleRelation/changeModuleState",
      payload: {
        key: "changeModuleState",
        apiParams: {
          id: studentModuleRelationId,
          startState, // true开始 false结束
        },
      },
    });
  }

  // 更换考卷
  handleChangeStudentExamPaper = () => {
    this.handleConform(
      "更换考卷后原有考卷数据将被遗弃，请谨慎操作！",
      () => {
        // 更换考卷时需要将tab下标置换为0
        this.setState({
          tabActiveKey: 0
        }, () => {
          this._getData({}, true);

          for (item in this.state) {
            if (item.includes("timer") || item.includes("title") || item.includes('moduleTimeOver')) {
              delete this.state[item];
            }
          }

          clearTimeout(this._timer);
          this.setState({ isStart: false });
        })
      },
      {
        okText: "更换考卷",
      }
    );
  };

  // 格式化时间
  formatTime = (arg) => {
    let hours, minutes, seconds;
    const duration =
      typeof arg === "number" ? moment.duration(arg, "milliseconds") : arg;
    hours = duration.hours() < 10 ? `0${duration.hours()}` : duration.hours();
    minutes =
      duration.minutes() < 10 ? `0${duration.minutes()}` : duration.minutes();
    seconds =
      duration.seconds() < 10 ? `0${duration.seconds()}` : duration.seconds();
    return hours + ":" + minutes + ":" + seconds;
  };

  handleTabChange = (activeKey) => {
    this.setState({ tabActiveKey: Number(activeKey), _index: null }, () => {
      this.updateTotalScore()
    });
  };

  // 更新总分
  updateTotalScore = (allData = this.state.allData) => {
    const { tabActiveKey } = this.state
    let totalScore = 0, currentModuleScore = 0, currentModuleTotalScore = 0;
    allData.forEach((val) => {
      val.answers &&
        val.answers.length &&
        val.answers.forEach((val) => {
          totalScore += val.score || 0;
        });
    });
    allData[tabActiveKey]?.answers.length && allData[tabActiveKey].answers.forEach(val => {
      currentModuleScore += val.score || 0,
        currentModuleTotalScore += val.maxScore || 0;
    })
    this.setState({
      ...this.state,
      totalScore,
      currentModuleScore: parseFloat(currentModuleScore).toFixed(1),
      currentModuleTotalScore,
      tableKey: new Date().getTime()
    });
  };

  // 远程认证开始/结束模块
  handleChangeModuleState = (e, milliseconds, stateName, title, index) => {
    e.stopPropagation();
    const { isReady, isStart } = this.state;
    if (!isReady) {
      message.warning({ content: "您还未开始认证，无法开始", key: "beginKey" });
      return;
    }

    if (this.state[title] === "结束") {
      this.setState({ isStart: false, ['moduleTimeOver' + index]: true });
      this._handleChangeModuleState(false, index);
      clearInterval(this._timer);
    } else {
      if (isStart) {
        message.warning({
          content: "有模块正在考核状态，无法开始",
          key: "beginKey",
        });
        return;
      }
      this.setState({ [title]: "结束", isStart: true });
      this._handleChangeModuleState(true, index);
      this.handleTimer(milliseconds, stateName, index);
    }
  };

  handleTimer = (milliseconds, stateName, index) => {
    // let formarDuration = this.state[stateName+index] && this.formatTime(this.state[stateName+index])
    if (this.state[stateName + index]) return;
    // if(formarDuration === '00:00:00') return;
    let duration =
      this.state[stateName + index] ||
      moment.duration(milliseconds, "milliseconds");
    const interval = 1000;
    this._timer = setInterval(() => {
      duration = moment.duration(duration - interval, "milliseconds");
      this.setState({
        [stateName]: this.formatTime(duration),
        [stateName + index]: duration,
      });
      if (
        duration.hours() == 0 &&
        duration.minutes() == 0 &&
        duration.seconds() == 0
      ) {
        clearInterval(this._timer);
        this.setState({ isStart: false });
        this._handleChangeModuleState(false, index);
      }
    }, interval);
  };

  // 修改认证状态
  handleSaveStudentExamPaper = () => {
    message.destroy()
    const { isReady } = this.state;
    if (isReady) {
      this.handleConform(
        "结束后将无法在进行考点得分修改，确认结束认证吗？",
        () => {
          this.setState({ moduleState: "结束" });

          clearTimeout(this._timer);
          this.setState({ isOver: true, isStart: false });
          this._handleSave({ isOver: true });

          // message.info('请点击右上角“X”关闭认证窗口')
        }
      );
    } else {
      this.setState({ isReady: true });
      this._updateAuthState();
    }
  };

  computeTotal = (index, score = null) => {
    // 更新总分
    let totalScore = 0, currentModuleScore = 0, currentModuleTotalScore = 0;
    const state = Object.assign({}, this.state);
    state.allData[this.state.tabActiveKey].answers[index].score = score;
    state.allData.forEach((val, index) => {
      val.answers.length &&
        val.answers.forEach((val) => {
          totalScore += val.score || 0;
          if (index === this.state.tabActiveKey) {
            currentModuleScore += val.score || 0;
            currentModuleTotalScore += val.maxScore || 0;
          }
        });
    });

    state.currentModuleScore = parseFloat(currentModuleScore).toFixed(1);
    state.currentModuleTotalScore = currentModuleTotalScore;
    state.totalScore = totalScore;

    this.setState({ ...state, _index: index, tableKey: new Date().getTime() });
  }

  handleInputClick = (e, index, maxScore, value) => {
    if (this.state._index === index) return
    this.computeTotal(index)
  }

  handleInputOnChange = (e, index, maxScore, value) => {
    message.destroy();
    let _val = e.currentTarget.value;
    if (_val === '') {
      this.computeTotal(index, '')
    }
    if (!_val.split('.').pop()) return;
    let score = _val && parseInt(_val * 10) / 10
    if (!score && score !== 0 && score !== '') {
      message.warning(`输入不合法,请重新输入`);
      score = Number(value) || null
    }
    if (score < 0) {
      message.warning(`分数设置不得低于0分`);
      score = Number(value) || null
    }
    if (score > maxScore) {
      message.warning(`分数设置超过最大值，已调整为${maxScore}分`);
      score = maxScore;
    }
    this.computeTotal(index, score)
  }

  handleEnter = (e, index, maxScore, value) => {
    this._handleSave({ isOver: false });
    this.setState({
      _index: index + 1,
      tableKey: new Date().getTime()
    })
  }

  // 保存试卷
  handleBlur = () => {
    this.setState({ _index: null })
    this._handleSave({ isOver: false });
  };

  handleConform = (content, onOk, other) => {
    WizModal.confirm({
      content,
      onOk,
      ...other,
    });
  };

  tabTitle = ({ moduleName, timer, index, state, ...item }) => {
    const _time = this.formatTime(timer * 1000);
    const _timeText = typeof (state["timer" + index] || _time) !== 'string' ? _time : state["timer" + index] || _time

    return (
      <div style={{ fontSize: 16 }}>
        <span>{moduleName}</span>
        <span style={{ margin: "0 10px" }}>
          {_timeText}
        </span>
        <WizButton
          type="link"
          style={{ color: _timeText === '00:00:00' || state["moduleTimeOver" + index] || item.endDate ? "#ccc" : "#e60021" }}
          disabled={item.endDate || _timeText === '00:00:00' || state["moduleTimeOver" + index]}
          onClick={(e) => {
            this.handleChangeModuleState(
              e,
              timer * 1000,
              "timer" + index,
              "title" + index,
              index
            );
          }}
        >
          {this.state.isOver ? state.moduleState : (state["title" + index] || item.endDate ? '结束' : '开始')}
        </WizButton>
      </div>
    );
  };

  toolbar = () => {
    const { isReady, isOver, totalScore, currentModuleScore, currentModuleTotalScore } = this.state;
    return (
      <div className="remote-table-toolbar-head">
        <WizButton
          type="danger"
          onClick={this.handleChangeStudentExamPaper}
          disabled={isOver}
        >
          更换考卷
        </WizButton>
        <span>学员：{fullName}</span>
        <span>当前模块得分：{currentModuleScore}/{currentModuleTotalScore}</span>
        <div>
          <span className="score">
            总分: {totalScore ? parseInt(totalScore * 10) / 10 : 0}
          </span>
          <WizButton
            type={!isReady ? "primary" : "danger"}
            onClick={this.handleSaveStudentExamPaper}
            disabled={isOver}
          >
            {!isReady ? "开始认证" : "结束认证"}
          </WizButton>
        </div>
      </div>
    )
  }

  // 单个模块分数自定义渲染
  scoreItemRender = (value, row, index) => {
    const inputProps = {
      // allowClear: true,
      disabled: !this.state.isReady,
      style: { fontSize: 16 },
      autoFocus: index === this.state._index ? true : false,
      defaultValue: value === 0 ? 0 : (value || ''),
      onChange: e => {
        this.handleInputOnChange(e, index, row.maxScore, value)
      },
      onBlur: e => {
        this.handleBlur();
      },
      onPressEnter: e => {
        this.handleEnter(e, index, row.maxScore, value);
      },
      onClick: e => {
        this.handleInputClick(e, index, row.maxScore, value)
      }
    }
    const obj = {
      children: !this.state.isOver ? (
        <WizInput {...inputProps} />
      ) : (
        value
      ),
      props: {},
    };
    return obj;
  };


  // 渲染函数
  render() {
    const { studentRemoteAuthDetailOfListLoading } = this.props;
    const { allData } = this.state;

    const dataTableProps = (val) => {
      const { answers, moduleContent } = val;

      return {
        key: this.state.tableKey,
        columns: columns(9999, this.scoreItemRender, moduleContent),
        rowKey: "id",
        bordered: true,
        loading: studentRemoteAuthDetailOfListLoading,
        size: "middle",
        dataItems: getPageData({ records: answers }),
        scroll: { y: window.innerHeight - 160 },
        tableLayout: 'fixed'
      };
    };

    let colSizeLeft = {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 8,
      xl: 6,
      xxl: 6
    }

    let colSizeRight = {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 16,
      xl: 18,
      xxl: 18
    }

    // 原来user-layout的高度是min-height = auto ,如果变成上下结构的栅格,会导致高度错误。所以使用js高度
    return (
      <WizSpin spinning={this.state.isOver}>
        <WizRow className="smart-classroom-remote-box" style={{ height: window.innerHeight }}>
          <WizCol  {...colSizeLeft} className="left-meeting">
            <Conference></Conference>
          </WizCol>
          <WizCol  {...colSizeRight} className="right-style">
            {this.toolbar()}
            {allData.length ? (
              <WizTabs
                animated={false}
                defaultActiveKey="0"
                onChange={this.handleTabChange}
                className="table-style"
              >
                {allData.map((val, index) => (
                  <WizTabs.TabPane
                    tab={this.tabTitle({
                      moduleName: val.moduleName,
                      timer: val.remainingTime,
                      index,
                      state: this.state,
                      ...val
                    })}
                    key={index}
                  >
                    <WizDataTable
                      {...dataTableProps(val)}
                      style={{ marginTop: -16 }}
                    />
                  </WizTabs.TabPane>
                ))}
              </WizTabs>
            ) : (
              <WizSpin spinning={studentRemoteAuthDetailOfListLoading}>
                <WizEmpty style={{ marginTop: 30 }} />
              </WizSpin>
            )}
          </WizCol>
        </WizRow>
      </WizSpin>
    );
  }
}

// 数据源
const mapStateToProps = (state, ownProps) => {
  const { studentModuleRelation, studentRemoteAuthDetailOfList, studentRemoteAuthDetail } = state;
  const list = modelUtils.getModelEntity(studentRemoteAuthDetailOfList, "getStudentExamPaper");
  const listOfChange = modelUtils.getModelEntity(studentRemoteAuthDetailOfList, "changeStudentExamPaper");
  const changeModuleState = modelUtils.getModelEntity(studentModuleRelation, "changeModuleState");
  const load = modelUtils.getLoadingState(state, "studentRemoteAuthDetailOfList");

  // 结束认证回调
  const saveExam = modelUtils.getModelEntity(studentRemoteAuthDetail, "saveStudentExamPaperToEnd");

  return { list, listOfChange, changeModuleState, saveExam, ...load };
};

export default connect(mapStateToProps)(smartClassroomRemote);
